import { Routes, Route, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import MainLayout from './components/layout/MainLayout';
import AuthGuard from './components/auth/AuthGuard';
import AdminGuard from './components/auth/AdminGuard';
import Spinner from './components/common/Spinner';

// Lazy load pages for code splitting
const LandingPage = lazy(() => import('./pages/LandingPage'));
const RecipePage = lazy(() => import('./pages/RecipePage'));
const FolderPage = lazy(() => import('./pages/FolderPage'));
const SearchResultsPage = lazy(() => import('./pages/SearchResultsPage'));
const SettingsPage = lazy(() => import('./pages/SettingsPage'));
const AdminPage = lazy(() => import('./pages/AdminPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

function App() {
  return (
    <Suspense fallback={<Spinner fullScreen />}>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />

        {/* Protected app routes */}
        <Route
          path="/app"
          element={
            <AuthGuard>
              <MainLayout />
            </AuthGuard>
          }
        >
          <Route index element={<Navigate to="/app/folder/all" replace />} />
          <Route path="folder/:folderId" element={<FolderPage />} />
          <Route path="recipe/:recipeId" element={<RecipePage />} />
          <Route path="search" element={<SearchResultsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Route>

        {/* Admin route */}
        <Route
          path="/admin"
          element={
            <AdminGuard>
              <AdminPage />
            </AdminGuard>
          }
        />

        {/* Public recipe view (for sharing) */}
        <Route path="/recipe/:slug" element={<RecipePage isPublic />} />

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}

export default App;
